import type { Label } from '@maestro/data-layer'

import classNames from 'classnames'
import React from 'react'

export default function ProductLabel(props: Label) {
  const { label, name, cssClass, backgroundColor, textColor, urlPath } = props

  const Tag = urlPath ? 'a' : 'span'

  return (
    <Tag
      className={classNames('product-label', {
        [`product-label--${cssClass}`]: cssClass,
        'product-label--link': urlPath,
      })}
      {...(name ? { title: name } : {})}
      {...(urlPath && {
        href: `/${urlPath}`,
      })}
      style={
        {
          ...(backgroundColor && {
            '--product-label-background-color': backgroundColor,
          }),
          ...(textColor && { '--product-label-color': textColor }),
        } as React.CSSProperties
      }
    >
      <span className="product-label__text">{label}</span>
    </Tag>
  )
}
